import type { FC } from "react";

import { Box, Stack, Typography } from "@mui/material";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

interface RulesTabShoptetCouponCodeProps {
  withRepeat: boolean;
  onToggleWithRepeat: () => void;
}

export const RulesTabShoptetCouponCode: FC<RulesTabShoptetCouponCodeProps> = ({
  withRepeat,
  onToggleWithRepeat,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Typography fontSize={14} style={{ marginBottom: 8, marginTop: 16 }}>
        {t("campaign.notifications.shoptetCouponCode.info")}
      </Typography>
      <Stack width='100%'>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography color={theme.palette.natural.t1}>
            {t(
              "campaign.notifications.settings.displayRules.repeatNotification",
            )}
          </Typography>
          <CustomSwitch checked={withRepeat} onSwitch={onToggleWithRepeat} />
        </Box>
      </Stack>
    </>
  );
};
